import { MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  padding: 2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    background-color: black;
    overflow: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: row;
  }
`;

export const Text = styled.div`
  opacity: ${(props) => (props.current ? "1" : "0.6")};
  font-weight: 700;
  font-size: 2rem;
  line-height: 3.6rem;
  color: ${(props) => (props.current ? MAIN_GREEN : "white")};
  cursor: pointer;
  &:hover {
    color: ${MAIN_GREEN};
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 1.8rem;
    line-height: 3.2rem;
    word-break: keep-all;
  }
`;
